/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetContentFilteringConfigurationsQueryResponse,
  GetContentFilteringConfigurationsPathParams,
} from "../types/GetContentFilteringConfigurations.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getContentFilteringConfigurationsQueryKey = (
  productSheetGroupId: GetContentFilteringConfigurationsPathParams["productSheetGroupId"]
) =>
  [
    {
      url: "/v1/organization-settings/get-content-filtering-configurations/:productSheetGroupId",
      params: { productSheetGroupId: productSheetGroupId },
    },
  ] as const

export type GetContentFilteringConfigurationsQueryKey = ReturnType<
  typeof getContentFilteringConfigurationsQueryKey
>

/**
 * @summary Get configurations by productSheetGroup and by scope
 * {@link /v1/organization-settings/get-content-filtering-configurations/:productSheetGroupId}
 */
export async function getContentFilteringConfigurations(
  productSheetGroupId: GetContentFilteringConfigurationsPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetContentFilteringConfigurationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-content-filtering-configurations/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getContentFilteringConfigurationsQueryOptions(
  productSheetGroupId: GetContentFilteringConfigurationsPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey =
    getContentFilteringConfigurationsQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetContentFilteringConfigurationsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetContentFilteringConfigurationsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getContentFilteringConfigurations(productSheetGroupId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get configurations by productSheetGroup and by scope
 * {@link /v1/organization-settings/get-content-filtering-configurations/:productSheetGroupId}
 */
export function useGetContentFilteringConfigurations<
  TData = ResponseConfig<GetContentFilteringConfigurationsQueryResponse>,
  TQueryData = ResponseConfig<GetContentFilteringConfigurationsQueryResponse>,
  TQueryKey extends QueryKey = GetContentFilteringConfigurationsQueryKey,
>(
  productSheetGroupId: GetContentFilteringConfigurationsPathParams["productSheetGroupId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetContentFilteringConfigurationsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getContentFilteringConfigurationsQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getContentFilteringConfigurationsQueryOptions(
        productSheetGroupId,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
